<template>
  <Dialog :commonDialog="commonDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex> Manage Payment Mode </v-flex>
        <v-flex class="text-right">
          <v-btn small class="mx-4" v-on:click="createPaymentMode">
            <span class="font-size-16 font-weight-600">Add Payment Mode</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-container class="py-0">
          <v-row class="py-0">
            <v-col md="12" class="py-0">
              <table class="width-100">
                <tbody>
                  <tr v-for="(type, index) in paymentModeList" :key="index">
                    <td>
                      <v-text-field
                        v-model.trim="type.text"
                        dense
                        filled
                        label="Payment Mode"
                        solo
                        flat
                        class="px-4 py-2"
                        hide-details
                        :disabled="pageLoading"
                        :loading="pageLoading"
                        color="cyan"
                      ></v-text-field>
                    </td>
                    <td width="50">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-on:click="deletePaymentMode(index)"
                            color="deep-orange"
                            v-bind="attrs"
                            v-on="on"
                            >mdi-delete</v-icon
                          >
                        </template>
                        <span>Click here to delete</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
        </v-container>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        :disabled="pageLoading"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updatePaymentMode"
      >
        Save
      </v-btn>
      <v-btn
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
export default {
  props: {
    commonDialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    paymentMode: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    paymentMode: {
      deep: true,
      immediate: true,
      handler(param) {
        this.paymentModeList = param;
      },
    },
  },
  data: () => {
    return {
      pageLoading: false,
      paymentModeList: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    updatePaymentMode() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/payment-mode",
          data: { payment_mode: _this.paymentModeList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.$emit("get-payment-mode", true);
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createPaymentMode() {
      this.paymentModeList.push({
        text: null,
      });
    },
    deletePaymentMode(index) {
      if (this.paymentModeList.length > 1) {
        this.paymentModeList.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
